import type { KudoUser, LabelInValue } from 'models';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { CommunityUsersSelect, type CommunityUsersSelectProperties } from 'features/communities/components';

type P = Omit<CommunityUsersSelectProperties<LabelInValue>, 'createOption'>;

export const createExpressingKudoOption = (user: KudoUser): LabelInValue => ({ label: user.fullName, value: user.id });

const ExpressingKudo = ({ communityIds, disabled, ...input }: P) => (
  <CommunityUsersSelect<LabelInValue>
    allowClear
    communityIds={communityIds}
    createOption={createExpressingKudoOption}
    disabled={communityIds.length === 0 || disabled}
    fullWidth
    placeholder="Choose member"
    {...input}
  />
);

export default ExpressingKudo;
